// Cancellation / Reinstatement section for the V2 Habitational policy-change
// right-side drawer.
//
// Renders the two fields the previous (v1) flow exposed for a
// Cancellation/Reinstatement change but that the V2 form dropped: the
// "Cancel Reason" (values.cancellation_reason) and the "Subtype"
// (values.sub_type — FLAT / SHORT RATE / PRO-RATA). Both edit the local draft
// held by ChangeSectionDrawer and are committed to Formik only on Save.

import React from "react";
import { Grid } from "@mui/material";
import {
  ControlledCustomSelect,
  CustomFormLabel,
} from "../../../../../../../../components/formsComponents";
import { IHabitationalPolicyChangeProps } from "../../Steps/HabitationalPolicyChange.types";
import {
  HabitationalPCRSubTypeOptions,
  otherCancellationReason,
} from "../../../../../../../../constants/constants";

interface ICancellationReinstatementV2Props
  extends IHabitationalPolicyChangeProps {
  // "Cancel" or "Reinstate" — chosen on the board. Kept for future
  // reinstatement-specific fields; both currently share the same two fields.
  mode?: string;
}

export const CancellationReinstatementV2: React.FC<
  ICancellationReinstatementV2Props
> = ({ values, handleChange }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <CustomFormLabel>Cancel Reason</CustomFormLabel>
        <ControlledCustomSelect
          variant="outlined"
          size="small"
          type="string"
          name="cancellation_reason"
          fullWidth
          displayEmpty
          value={values.cancellation_reason ?? ""}
          onChange={handleChange}
          placeholder="Select One"
          options={otherCancellationReason}
          // Rendered inside the V2 right-side drawer (zIndex 1400); the menu
          // portals to the body at the default modal zIndex (1300) and would
          // open behind the drawer. Keep it above the drawer.
          MenuProps={{ sx: { zIndex: 1600 } }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CustomFormLabel>Subtype</CustomFormLabel>
        <ControlledCustomSelect
          variant="outlined"
          size="small"
          type="string"
          name="sub_type"
          fullWidth
          displayEmpty
          value={values.sub_type ?? ""}
          onChange={handleChange}
          placeholder="Select One"
          options={HabitationalPCRSubTypeOptions.CancellationReinstatement}
          MenuProps={{ sx: { zIndex: 1600 } }}
        />
      </Grid>
    </Grid>
  );
};
